<template>
  <d-container fluid>
    <d-form @submit.prevent="submit()">
      <d-row>
        <d-col sm="12" md="12" lg="9">
          <d-card>
            <h3 class="table-title mb-0 p-3">Resultados Químico</h3>
            <chemical-result-table :chemical.sync="model.chemical" />
          </d-card>
        </d-col>
      </d-row>
      <d-row class="mt-4">
        <d-col sm="12" md="12" lg="9">
          <d-card>
            <h3 class="table-title m-0 p-3">Resultados Ruído</h3>
            <d-tabs class="custom-tabs">
              <d-tab title="NHO" :active="selectedNoiseModel === 'nho'" class="p-0">
                <noise-result-table :noise.sync="model.noise.nho" type="nho" />
              </d-tab>
              <d-tab title="NR15" :active="selectedNoiseModel === 'nr15'" class="p-0">
                <noise-result-table :noise.sync="model.noise.nr15" type="nr15" />
              </d-tab>
            </d-tabs>
          </d-card>
        </d-col>
      </d-row>
      <d-form-row class="mt-4">
        <d-button class="btn-primary" type="submit">Salvar</d-button>
      </d-form-row>
    </d-form>
  </d-container>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import SettingsService from '_services/rest/modules/settings';
import formatErrors from '_common/mixins/FormatErrors';
import ChemicalResultTable from './ResultTables/ChemicalResultTable';
import NoiseResultTable from './ResultTables/NoiseResultTable';
import { _LOAD_MODEL_RESULTS_, RESULTS } from './SettingsModel';

export default {
  name: 'result-form',
  mixins: [formatErrors],
  components: {
    NoiseResultTable,
    ChemicalResultTable,
  },
  data() {
    return {
      model: { ...RESULTS },
      selectedNoiseModel: 'nho',
    };
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'getSettings',
    ]),
    checkForm() {
      return this.checkChemicalFields() && this.checkNoiseFields();
    },
    checkChemicalFields() {
      const { risks } = this.model.chemical;
      const fields = ['min', 'max'];

      const hasInvalidFieldRisks = Object.values(risks).some(risk =>
        this.isInvalidField(risk, fields));

      if (hasInvalidFieldRisks) {
        this.activeAlert({
          message: 'Os campos de índice de risco precisam ser um número.',
          theme: 'danger',
        });
        return false;
      }

      return true;
    },
    checkNoiseFields() {
      const { nho, nr15 } = this.model.noise;
      const fields = ['dailyDoseMin', 'dailyDoseMax', 'min', 'max'];

      const hasInvalidFieldNHO = Object.keys(nho).some(level => this.isInvalidField(nho[level], fields));
      const hasInvalidFieldNR15 = Object.keys(nr15).some(level => this.isInvalidField(nr15[level], fields));

      if (hasInvalidFieldNHO || hasInvalidFieldNR15) {
        this.activeAlert({
          message: 'Os campos de Dose diária, NHO ou NR15 precisam ser um número.',
          theme: 'danger',
        });
        return false;
      }

      return true;
    },
    isInvalidField(data, fields) {
      const numberRegex = /^\d*[.,]?\d+$/;

      return fields.some(field => (data[field] !== undefined) && !numberRegex.test(data[field]));
    },
    submit() {
      this.loading = true;
      if (this.checkForm()) {
        try {
          SettingsService.saveOptions(this.model, 'result')
            .then(() => {
              this.getSettings();
              this.activeAlert({
                message: 'Configurações salvas com sucesso',
                theme: 'success',
              });
            });
        } catch (error) {
          this.showError(error);
        } finally {
          this.loading = false;
        }
      }
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_RESULTS_, newValue => {
      this.model = { ...newValue };
    });
  },
};
</script>

<style lang="scss">
.row-container {
  align-items: center;
  flex-wrap: nowrap;
  margin-left: 5px;
  gap: 8px;
  color: #5A6169;
}

.row-container input {
  min-width: 40px;
  color: inherit;
}

.row-container span {
  white-space: nowrap;
  color: inherit;
}

.text-input {
  min-width: 50px;
  color: inherit;
}

.bg-grey {
  background-color: #F6F6F6;
}

.table-title {
  font-size: 16px;
  font-weight: bold;
  color: #424242;
}

.custom-tabs .nav-tabs {
  padding-left: 10px;
}

.custom-tabs .nav-tabs .nav-item .active {
  background-color: #F6F6F6;
}
</style>
